(function () {
  'use strict';

  const EXTERNAL_ANALYTICS_FIELDS = Object.freeze({
    content_name: true,
    question_number: true,
    input_type: true,
    total_questions: true,
    contact_type: true,
    concern_level: true,
    _fbStandard: true,
    _fbEventId: true,
    _gaEvent: true,
  });

  function sanitizeAnalyticsData(data) {
    if (!data || typeof data !== 'object') return {};

    return Object.keys(data).reduce((safeData, field) => {
      if (!EXTERNAL_ANALYTICS_FIELDS[field]) return safeData;
      const value = data[field];
      if (value === null || ['string', 'number', 'boolean'].includes(typeof value)) {
        safeData[field] = value;
      }
      return safeData;
    }, {});
  }

  function track(instance, eventName, data) {
    const analyticsData = sanitizeAnalyticsData(data);

    try {
      window.TaraMetaSignals?.track(instance, eventName, analyticsData);
    } catch (error) { /* analytics is best-effort */ }

    try {
      if (typeof gtag === 'function') {
        const gaEvent = analyticsData._gaEvent || eventName;
        const { _fbStandard, _fbEventId, _gaEvent: _, ...gaData } = analyticsData;
        gtag('event', gaEvent, gaData);
      }
    } catch (error) { /* analytics is best-effort */ }
  }

  function identifyKlaviyo(instance, email, subscribe) {
    if (!subscribe || !email) return;

    try {
      const _learnq = window._learnq || [];

      _learnq.push(['identify', {
        '$email': email,
        'Tara Hair Consultation - Completed': true,
        'Tara Hair Consultation - Date': new Date().toISOString(),
        '$consent': ['email'],
      }]);

      _learnq.push(['track', 'Tara Hair Consultation Completed', {
        total_questions: instance.questionCount,
        completed_at: new Date().toISOString(),
      }]);
    } catch (error) { /* analytics is best-effort */ }
  }

  window.TaraConsultationAnalytics = Object.freeze({
    sanitizeAnalyticsData,
    track,
    identifyKlaviyo,
  });
})();
